import session from "@/services/SessionService";
import config from "@/config";
import { AxiosPromise } from "axios";
import { SearchPagination, SearchFilters } from "./SearchService";
import { Log } from "@/models/Log";
/**
 * Type for all available user filters
 */
export type LogSearch = {
  pagination: SearchPagination;
  filters: SearchFilters;
};

/**
 * Response type for document data
 */
type LogGetResponse =
  | { events: Log[]; pagination: SearchPagination }
  | undefined;

/**
 * Singleton class for fetching document data from the API
 */
class LogService {
  private endpoint: string = config.hostname + "/events/";

  /**
   * Fetch all logs matching the filters provided
   *
   * @param {LogSearch} filters
   *
   */
  get(params: LogSearch): AxiosPromise<LogGetResponse> {
    let promise: AxiosPromise<LogGetResponse>;
    promise = session.requestWithAuth("get", this.endpoint, params);
    return promise;
  }
}

let logService = new LogService();

export default logService;
